import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Modal, Field } from '../ui/Modal';
import { Icon } from '../ui/Icon';
import { api, ApiError } from '../../lib/api';
import { toast } from '../../stores/toast.store';

export function NewClientNoteModal({ onClose, clientId }: { onClose: () => void; clientId: string }) {
  const qc = useQueryClient();
  const [body, setBody] = useState('');
  const [pinned, setPinned] = useState(false);

  const create = useMutation({
    mutationFn: () => api.post(`/clients/${clientId}/notes`, { body, pinned }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['client-notes', clientId] });
      toast.ok('Nota salvata', pinned ? 'Fissata in cima' : undefined);
      onClose();
    },
    onError: (err) => toast.alert('Errore salvataggio nota', err instanceof ApiError ? err.message : 'Riprova'),
  });

  return (
    <Modal
      title="Nuova nota interna"
      kicker="CRM · Note cliente"
      onClose={onClose}
      size="md"
      footer={
        <>
          <button className="btn btn-ghost" onClick={onClose}>Annulla</button>
          <div className="spacer" />
          <button className="btn btn-primary" onClick={() => create.mutate()} disabled={!body.trim() || create.isPending}>
            Salva <Icon name="check" size={12} />
          </button>
        </>
      }
    >
      <div className="form-grid">
        <Field label="Testo" required span={12}>
          <textarea className="inp" rows={5} placeholder="Annota qualcosa di rilevante sul cliente…" autoFocus value={body} onChange={(e) => setBody(e.target.value)} />
        </Field>
        <Field span={12}>
          <label className="flex items-center gap-2 text-[13px]">
            <input type="checkbox" checked={pinned} onChange={(e) => setPinned(e.target.checked)} />
            Fissa in cima (nota importante)
          </label>
        </Field>
      </div>
    </Modal>
  );
}
